<template>
  <div class="" :class="{'without-print': !isShowPrint, 'without-download': !isShowDownload}">
    <span @click="$emit('closePdf')" class="pdf-viewer-close-button">×</span>
    <ejs-pdfviewer
        :id="id"
        :resourceUrl="resourceUrl"
        :printMode="printMode"
        :documentPath="documentPath"
        :style="{'height': documentHeight + 'px'}"
    ></ejs-pdfviewer>
  </div>
</template>

<script>
import { PdfViewerComponent, Toolbar, Magnification, Navigation, Print } from "@syncfusion/ej2-vue-pdfviewer"
import { browserName } from 'mobile-device-detect';
export default {
  name: "pdf-viewer",
  components: {
    'ejs-pdfviewer': PdfViewerComponent
  },
  provide: {
    PdfViewer: [Toolbar, Navigation,  Print, Magnification]
  },
  props: {
    documentHeight: {
      type: Number,
      default: 500
    },
    documentPath: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'pdfViewer'
    },
    isShowPrint: {
      type: Boolean,
      default: true
    },
    isShowDownload: {
      type: Boolean,
      default: true
    },
  },
  mounted() {
    if (browserName === 'Chrome') {
      this.printMode = 'NewWindow'
    }
  },
  data () {
    return {
      resourceUrl:'https://cdn.syncfusion.com/ej2/23.1.43/dist/ej2-pdfviewer-lib',
      printMode: null,
    }
  }
}
</script>

<style>
.without-print #pdfViewer_printContainer,
.without-print #pdfViewer2_printContainer{
  display: none !important;
}
.without-download #pdfViewer_downloadContainer,
.without-download #pdfViewer2_downloadContainer {
  display: none !important;
}
#pdfViewer_sideBarToolbar,
#pdfViewer_open,
#pdfViewer_handTool,
#pdfViewer_selectToolContainer,
#pdfViewer_handToolContainer,
#pdfViewer_redo,
#pdfViewer_undo,
#pdfViewer_comment,
#pdfViewer_submitForm,
#pdfViewer_search,
#pdfViewer_annotation,
#pdfViewer_formdesigner,

#pdfViewer2_sideBarToolbar,
#pdfViewer2_open,
#pdfViewer2_handTool,
#pdfViewer2_selectToolContainer,
#pdfViewer2_handToolContainer,
#pdfViewer2_redo,
#pdfViewer2_undo,
#pdfViewer2_comment,
#pdfViewer2_submitForm,
#pdfViewer2_search,
#pdfViewer2_annotation,
#pdfViewer2_formdesigner,

.e-separator {
  display: none !important;
}
#pdfViewer_currentPageInput,
#pdfViewer2_currentPageInput {
  pointer-events: none;
}
#pdfViewer_toolbarContainer,
#pdfViewer2_toolbarContainer {
  z-index: 9999;
}

.e-toolbar-right {
  margin-right: 40px;
}
.pdf-viewer-close-button {
  position: absolute;
  right: 21px;
  z-index: 10000;
  transform: translate(2px, 3px);
  font-size: 30px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54)
}
</style>
